"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientCookieManager = exports.init = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const server_vars_1 = __importDefault(require("server-vars"));
const canSetCookie_1 = require("./canSetCookie");
const DEFAULT_COOKIE_EXPIRATION_IN_DAYS = 182;
const defaultCookieSettings = {
    domain: server_vars_1.default === null || server_vars_1.default === void 0 ? void 0 : server_vars_1.default.get('cookieDomain'),
    expires: DEFAULT_COOKIE_EXPIRATION_IN_DAYS,
    path: '/',
};
const init = (attributes = {}, cookiesCategoryMap = {}) => {
    const api = js_cookie_1.default.withAttributes(attributes);
    cookiesCategoryMap = Object.freeze(cookiesCategoryMap);
    const newApi = Object.create(api);
    newApi.set = (name, value, options) => {
        if ((0, canSetCookie_1.canSetCookie)(document.cookie, name, cookiesCategoryMap)) {
            return api.set(name, value, options);
        }
        return undefined;
    };
    newApi.withCookieCategoryMap = (newCookiesCategoryMap) => {
        return (0, exports.init)(attributes, newCookiesCategoryMap);
    };
    newApi.withAttributes = (newAttributes) => {
        return (0, exports.init)(Object.assign(Object.assign({}, attributes), newAttributes), cookiesCategoryMap);
    };
    return newApi;
};
exports.init = init;
exports.ClientCookieManager = (0, exports.init)(defaultCookieSettings, (server_vars_1.default === null || server_vars_1.default === void 0 ? void 0 : server_vars_1.default.get('browserStorageInfo.cookies')) || {});
//# sourceMappingURL=ClientCookieManager.js.map